const absencesData = [
    {
        time: "8:30 am",
        id: "72836301",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-08-09",
        daysRequested: 3,
        remainingDays: 5,
    },
    {
        time: "9:15 am",
        id: "72803931",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-08-12",
        daysRequested: 2,
        remainingDays: 1,
    },
    {
        time: "10:45 am",
        id: "72823931",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-08-12",
        daysRequested: 4,
        remainingDays: 6,
    },
    {
        time: "7:00 am",
        id: "72823986",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-08-21",
        daysRequested: 4,
        remainingDays: 6,
    },
    {
        time: "7:15 am",
        id: "72743986",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-08-13",
        daysRequested: 3,
        remainingDays: 3,
    },
    {
        time: "9:00 am",
        id: "72936302",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-09-05",
        daysRequested: 2,
        remainingDays: 4,
    },
    {
        time: "10:00 am",
        id: "72936303",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-09-07",
        daysRequested: 1,
        remainingDays: 5,
    },
    {
        time: "8:45 am",
        id: "73036304",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-09-03",
        daysRequested: 3,
        remainingDays: 2,
    },
    {
        time: "11:00 am",
        id: "73036305",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-08-11",
        daysRequested: 2,
        remainingDays: 3,
    },
    {
        time: "8:00 am",
        id: "72736307",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-07-04",
        daysRequested: 2,
        remainingDays: 7,
    },
    {
        time: "9:00 am",
        id: "72736308",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-07-10",
        daysRequested: 3,
        remainingDays: 4,
    },
    {
        time: "8:45 am",
        id: "72636309",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-06-08",
        daysRequested: 1,
        remainingDays: 6,
    },
    {
        time: "10:00 am",
        id: "72636310",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-06-15",
        daysRequested: 4,
        remainingDays: 2,
    },
    {
        time: "7:30 am",
        id: "72536311",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-05-03",
        daysRequested: 2,
        remainingDays: 8,
    },
    {
        time: "11:15 am",
        id: "72536312",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-05-17",
        daysRequested: 3,
        remainingDays: 5,
    },
    {
        time: "11:15 am",
        id: "72536984",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-05-17",
        daysRequested: 3,
        remainingDays: 5,
    },
    {
        time: "8:00 am",
        id: "73136301",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-10-04",
        daysRequested: 2,
        remainingDays: 7,
    },
    {
        time: "9:30 am",
        id: "73136302",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-10-10",
        daysRequested: 3,
        remainingDays: 4,
    },
    {
        time: "10:15 am",
        id: "73136303",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-10-15",
        daysRequested: 1,
        remainingDays: 6,
    },
    {
        time: "7:00 am",
        id: "73136304",
        requestType: "Scheduled absences",
        bgColor: "bg-green-icon",
        date: "2023-10-20",
        daysRequested: 4,
        remainingDays: 2,
    },
    {
        time: "7:30 am",
        id: "73136305",
        requestType: "Authorized exceptions",
        bgColor: "bg-yellow-icon",
        date: "2023-10-25",
        daysRequested: 2,
        remainingDays: 3,
    }
];

export default absencesData;
